import React from "react";
import Page from "../../assets/img/404.png";

export const PageNotFound = () => <img src={Page} alt="page" />;
